import { AppBar, Badge, Button, Dialog, Tooltip, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Toolbar, Typography } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import NotificationsPopover from 'src/components/NotificationsPopover';
import { getNotifications, notifyNotificationViewed } from 'src/store/api/notificationsApi';
import { getSepetAdet, getUser, handleLogoutMain, setSepetAdet } from 'src/utils/Common';
import { baseURL } from 'src/utils/contants';
import { closeAlert, getTasksRequest } from '../../store/actions';
import { useOktaAuth } from '@okta/okta-react';
import SmartToyIcon from '@mui/icons-material/SmartToy';

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
  },
  table: {
    minWidth: 600
  },
  flexGrow: {
    flexGrow: 1
  },
  title: {
    flexGrow: 1,
    marginBottom: theme.spacing(-1),
    marginLeft: theme.spacing(1)
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function TopBar({ onOpenNavBar, className, getTasksRequest, alertReducer, closeAlert }) {
  const classes = useStyles();
  const history = useHistory();
  const notificationsRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [showNotificationList, setShowNotificationList] = useState(false);
  const [MenuShow, setMenuShow] = useState(false);
  const [sepetAdetDeger, setSepetAdetDeger] = useState(0);
  const [FiyatDegisiklikAdet, setFiyatDegisiklikAdet] = useState(0);
  const [openBasket, setopenBasket] = useState(false);
  const [openFiyatDegisiklik, setopenFiyatDegisiklik] = useState(false);
  const [Counting, setCounting] = useState(false);
  const [SepetData, setSepetData] = useState([]);
  const [FiyatData, setFiyatData] = useState([]);
  const SessionUser = getUser();
  const { oktaAuth } = useOktaAuth();

  const handleClickNotification = ({ ID, Url }) => {
    setShowNotificationList(false);
    //notify server that was read
    notifyNotificationViewed(ID);
    getTasksRequest();
    if (Url.match(baseURL)) {
      history.push(Url.replace(baseURL, ''));
    } else {
      window.open(Url, '_blank');
    }
    //remove clicked notification
    setNotifications(notifications => notifications.filter(notification => notification.ID !== ID));
  };
  const handleCloseBasket = () => {
    setopenBasket(false);
  };
  const handleCloseFiyatDegisiklik = () => {
    setopenFiyatDegisiklik(false);
  };
  const handleCloseCounting = () => {
    setCounting(false);
  };

  var Deger = getSepetAdet();

  useEffect(() => {
    var Deger = getSepetAdet();
    setSepetAdetDeger(Deger);
    if (SessionUser.Counting === 1) {
      setCounting(true);
    }

  }, [Deger]);

  const handleDeleteAll = () => {
    setShowNotificationList(false)
    confirmAlert({
      message: "Tüm Bildirimleriniz Silinecektir. Onaylıyor Musunuz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => deleteYes()
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
    const deleteYes = () => {
      notifications.forEach(e => {
        notifyNotificationViewed(e.ID);
      });
      getNotifications()
        .then(res => {
          res.data && setNotifications(res.data);
        });
    }
  }
  const setMenuShowFnc = () => {
    if (MenuShow) {
      setMenuShow(false);
    } else {
      setMenuShow(true);
    }
    onOpenNavBar();
  }

  const Beyaz = {
    color: '#FFFFFF'
  };

  const Logout = async () => {
    handleLogoutMain();
    await oktaAuth.signOut();

  };

  const handleChatBotLink = () => {
    const chatbotUrl = SessionUser.Role_Id === 10 
      ? "https://apollochatbot.beko.com/" 
      :  "https://servicemate.beko.com/";
    window.open(chatbotUrl, "_blank");
  };

  const canAccessChatbot = (
    SessionUser.Role_Id !== 4 &&
    SessionUser.Role_Id !== 11 &&
    !(SessionUser.Role_Id === 9 && (SessionUser.ManagementRoleId !== 1 && SessionUser.ManagementRoleId !== 2))
  );

  return (
    <AppBar
      className={clsx(classes.root, className)}
      style={{ background: '#424242' }}
    >
      <Toolbar>
        <IconButton
          className={classes.menuButton}
          style={Beyaz}
          onClick={setMenuShowFnc}
          data-tour="OpenNavbarButton">
          {MenuShow ? <MenuIcon /> : <MenuOpenIcon />}
        </IconButton>
        <Typography
          variant="h4"
          component="h3"
          style={{ fontFamily: 'AssistantRegular', color: '#FF9800', paddingTop: 3 }}
        >
          apollo
        </Typography>
        <Typography variant="h6" className={classes.title}>

        </Typography>
        {canAccessChatbot ?
          <Tooltip title="Chatbot linkine yönlendirileceksiniz!...">
            <IconButton
              className={classes.iconButton}
              onClick={handleChatBotLink}
              ref={notificationsRef}
            >
              <Badge
                style={Beyaz}
              >
                <SmartToyIcon sx={{ color: '#FF9800' }} />
              </Badge>
            </IconButton>
          </Tooltip>
          : null}
        <IconButton
          className={classes.iconButton}
          onClick={() => setShowNotificationList(true)}
          ref={notificationsRef}
        >
          <Badge
            style={Beyaz}
            badgeContent={notifications.length}
          >
            <NotificationsActiveIcon color="primary" />
          </Badge>
        </IconButton>
        <IconButton
          className={classes.menuButton}
          style={Beyaz}
          //onClick={handleLogoutMain}
          onClick={() => Logout()}
          data-tour="LogoutButton">
          <ExitToAppIcon color="primary" />
        </IconButton>
      </Toolbar>
      <NotificationsPopover
        anchorEl={notificationsRef.current}
        notifications={notifications}
        onClickNotification={handleClickNotification}
        onClose={() => setShowNotificationList(false)}
        open={showNotificationList}
        handleDeleteAll={handleDeleteAll}
      />
      <Dialog
        open={alertReducer.open}
        onClose={() => closeAlert()}
      >
        <DialogTitle color="primary">{alertReducer.title}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            {alertReducer.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => closeAlert()}
            color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBar: PropTypes.func
};

export default connect(
  state => ({ alertReducer: state.alertReducer }),
  {
    getTasksRequest, closeAlert
  }
)(TopBar);
